import { useParams } from 'react-router-dom';
import { MODULES } from '@/config/modules.config';
import { useI18n } from '@/i18n';

const CONTENT_PIPELINE = ['Idea', 'Research', 'Script', 'Shoot', 'Edit', 'Review', 'Ready', 'Scheduled', 'Published', 'Performance'];

const PLANNED_CAPABILITIES: Record<string, string[]> = {
  content: ['Content pipeline board (Idea → Published)', 'Script + brief templates', 'Approval routing before publish', 'Performance rollup per creator/campaign'],
  crm: ['Lead capture from website + ads', 'Pipeline stages and scoring', 'Marketing-to-sales handoff'],
  social: ['Unified post scheduler across platforms', 'Cross-platform performance rollup', 'Comment/DM inbox'],
  ads: ['Campaign management for Meta/Google/TikTok Ads', 'Budget pacing and alerts', 'Creative performance comparison'],
  clients: ['Client roster distinct from Creators/Partners', 'Project + deliverable tracking per client'],
  projects: ['Task boards linked to Clients/Partnerships', 'Timeline and ownership tracking'],
  finance: ['Revenue and expense tracking', 'Invoicing tied to Partnerships/Contracts', 'Payout tracking against the profit-sharing ledger'],
};

/**
 * A real, useful landing page for every "Coming next" sidebar item —
 * clicking Content/CRM/Social/Ads/Clients/Projects/Finance was previously
 * a dead, unclickable row; now it explains what's planned instead of
 * doing nothing. No live data is faked here.
 */
export function ComingSoonPage() {
  const { moduleId } = useParams();
  const { t } = useI18n();
  const module = MODULES.find((m) => m.id === moduleId);
  const capabilities: string[] = moduleId ? (PLANNED_CAPABILITIES[moduleId] ?? []) : [];

  return (
    <div>
      <h1>{module ? t(module.labelKey) : moduleId}</h1>
      <div className="card" style={{ padding: 24 }}>
        <span className="soon-tag-inline" style={{ marginBottom: 12, display: 'inline-block' }}>{t('common.comingSoon')}</span>
        <p style={{ color: 'var(--text-2)', marginTop: 0 }}>{t('comingSoon.explanation')}</p>

        {moduleId === 'content' && (
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', margin: '16px 0' }}>
            {CONTENT_PIPELINE.map((stage, i) => (
              <span key={stage} className="badge info">{i + 1}. {stage}</span>
            ))}
          </div>
        )}

        {capabilities.length > 0 && (
          <>
            <div style={{ fontWeight: 700, marginTop: 16, marginBottom: 8 }}>{t('comingSoon.planned')}</div>
            <ul style={{ margin: 0, paddingInlineStart: 20, color: 'var(--text-2)', fontSize: 13.5 }}>
              {capabilities.map((c) => <li key={c} style={{ marginBottom: 6 }}>{c}</li>)}
            </ul>
          </>
        )}
      </div>
    </div>
  );
}
